import {
  UPDATE_QUADRANT_I,
  UPDATE_QUADRANT_II,
  UPDATE_QUADRANT_III,
  UPDATE_QUADRANT_IV,
  UPDATE_SITE,
  UPDATE_METADATA,
  TOGGLE_SLIDER
} from '../types';

export const updateQuadrantI = product => {
  return {
    type: UPDATE_QUADRANT_I,
    payload: { product }
  };
};

export const updateQuadrantII = product => {
  return {
    type: UPDATE_QUADRANT_II,
    payload: { product }
  };
};

export const updateQuadrantIII = product => {
  return {
    type: UPDATE_QUADRANT_III,
    payload: { product }
  };
};

export const updateQuadrantIV = product => {
  return {
    type: UPDATE_QUADRANT_IV,
    payload: { product }
  };
};

export const updateSite = site => {
  return {
    type: UPDATE_SITE,
    payload: site
  };
};

export const updateMetadata = value => {
  return {
    type: UPDATE_METADATA,
    payload: value
  };
};

export const toggleSlider = () => {
  return {
    type: TOGGLE_SLIDER
  };
};